/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PasskeyLoginOptionsResponse { 
    /**
     * Challenge casuale codificato in Base64URL
     */
    challenge: string;
    /**
     * Identificativo della Relying Party (dominio)
     */
    rp_id: string;
    /**
     * Lista di credential ID ammessi, codificati in Base64URL
     */
    allow_credentials: Array<string>;
    /**
     * Session ID da rimandare in /login/verify (UUID)
     */
    session_id: string;
}

